import React, { useEffect } from 'react';
import {
  Outlet
  , Link
  , useLocation
  , useNavigate
} from 'react-router-dom';

import {
  Container
  , Image
  , Nav
  , Navbar
  , NavDropdown
} from 'react-bootstrap';

import { Avatar } from 'rsuite'; // Import Avatar from rsuite

// images
import Banner from '../../images/banner.png';

const Home = () => {
  const location = useLocation();
  const navigate = useNavigate(); // Use navigate for redirection

  useEffect(() => {
    // Check if signed exists in localStorage
    const signed = localStorage.getItem('signed');
    if (!signed) {
      // Redirect to login if signed is absent
      navigate('/admin/login');
    }
  }, [navigate]);

  const handleSignOut = () => {
    // Remove the signed from localStorage
    localStorage.removeItem('signed');

    // Redirect to login page
    navigate('/admin/login');
  };

  // Render nothing while redirecting
  if (!localStorage.getItem('signed')) {
    return null;
  }

  return (
    <Container>
      <Image src={Banner} fluid />
      <Navbar className='shadow-sm rounded' expand="lg" bg="light" data-bs-theme="light" variant="light">
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Link className={`nav-link ${location.pathname === '/admin' ? 'active' : ''}`} to="/admin">Dashboard</Link>
            <Link className={`nav-link ${location.pathname === '/admin/applicant' ? 'active' : ''}`} to="/admin/applicant">ข้อมูลผู้สมัคร</Link>
            <Link className={`nav-link ${location.pathname === '/admin/approved' ? 'active' : ''}`} to="/admin/approved">นักเรียนที่ได้รับทุนแล้ว</Link>
            <Link className={`nav-link ${location.pathname === '/admin/activities' ? 'active' : ''}`} to="/admin/activities">กิจกรรมของนักเรียนหรือเยาวชน</Link>
            <Link className={`nav-link ${location.pathname === '/admin/counseling' ? 'active' : ''}`} to="/admin/counseling">การขอคำปรึกษา</Link>
            <Link className={`nav-link ${location.pathname === '/admin/report' ? 'active' : ''}`} to="/admin/report">รายงาน</Link>
            <NavDropdown title={'ผู้ดูแลระบบ'}>
              <Link className={`dropdown-item ${location.pathname === '/admin/announcement' ? 'active' : ''}`} to="/admin/announcement">เปิด-ปิดการรับสมัคร</Link>
              <Link className={`dropdown-item ${location.pathname === '/admin/ethnic' ? 'active' : ''}`} to="/admin/ethnic">รายชื่อชนเผ่า</Link>
              <Link className={`dropdown-item ${location.pathname === '/admin/village' ? 'active' : ''}`} to="/admin/village">รายชื่อหมู่บ้าน</Link>
              <Link className={`dropdown-item ${location.pathname === '/admin/schools' ? 'active' : ''}`} to="/admin/schools">รายชื่อสถานศึกษา</Link>
              <Link className={`dropdown-item ${location.pathname === '/admin/users' ? 'active' : ''}`} to="/admin/users">ผู้สมัครเข้าใช้งานระบบ (Users)</Link>
              <Link className={`dropdown-item ${location.pathname === '/admin/administrator' ? 'active' : ''}`} to="/admin/administrator">ผู้ดูแลระบบ (Admin)</Link>
            </NavDropdown>
          </Nav>
          <Nav className="ms-auto">
            <NavDropdown
              title={
                <span>
                  <Avatar size="sm" circle style={{ marginRight: '8px' }}>
                    <i className="bi bi-person-fill"></i>
                  </Avatar>
                  <span>{JSON.parse(localStorage.getItem('signed')).data.username}</span>
                </span>
              }
            >
              <NavDropdown.Item onClick={handleSignOut}>ออกจากระบบ</NavDropdown.Item>
            </NavDropdown>
          </Nav>
        </Navbar.Collapse>
      </Navbar>

      <Outlet />

    </Container>
  );
};

export default Home;